import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { SpinnerLoading } from "../components/Loadings";
import toast from "react-hot-toast";
import envFile from "../envFile";
import { accessToken } from "../Utility";

export default function Verification() {
  const [loading, setLoading] = useState();
  const { id } = useParams();
  const [userId, uuid] = id.split("~");
  const navigate = useNavigate();

  useEffect(() => {
    userVerify();
  }, []);

  const userVerify = async () => {
    try {
      setLoading(true);
      // const response = await axios.post(`${envFile.EMAIL_VERIFICATION_LINK}/Tenant/${userId}/${uuid}/verify`);
      const res = await accessToken();
      const response = await axios.post(
        `${envFile.PUBLIC_API_LINK}/verifyEmail`,
        {
          role: "Tenant",
          id: userId,
          uuid,
        },
        {
          headers: {
            Authorization: res.data.access_token,
          },
        }
      );

      setLoading(false);

      if (response.data?.status === 200) {
        navigate("/");
      } else {
        toast.error(response.data?.response || "Invalid Link!");
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Invalid Link!");
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && (
        <div className="loadingSpinner">
          <SpinnerLoading />
        </div>
      )}
    </div>
  );
}
